import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY } from "@/data/products";

const CARDS = [
  {
    icon: Mail,
    title: "Email",
    value: COMPANY.email,
    href: `mailto:${COMPANY.email}`,
    testid: "contact-email",
  },
  {
    icon: Phone,
    title: "Phone / WhatsApp",
    value: COMPANY.phoneDisplay,
    href: `tel:${COMPANY.phoneTel}`,
    testid: "contact-phone",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="py-20 md:py-28 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-[#0d7a72] text-sm font-bold tracking-[0.25em] uppercase mb-3">Get In Touch</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#10233f] mb-4" data-testid="contact-heading">
          Contact Us
        </h2>
        <p className="text-base text-[#5a6b85] max-w-2xl mb-12">
          Questions about a product, an order, or a partnership? Reach us by email, phone or WhatsApp.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {CARDS.map((c) => (
            <a
              key={c.title}
              href={c.href}
              data-testid={c.testid}
              className="block bg-[#f7f5f1] border border-[#e6e1d8] rounded-2xl p-7 card-lift"
            >
              <c.icon className="w-6 h-6 text-[#0d7a72] mb-4" />
              <h3 className="font-bold text-[#10233f] mb-1.5">{c.title}</h3>
              <p className="text-sm text-[#5a6b85] break-all">{c.value}</p>
            </a>
          ))}
          <div className="bg-[#f7f5f1] border border-[#e6e1d8] rounded-2xl p-7" data-testid="contact-address">
            <MapPin className="w-6 h-6 text-[#0d7a72] mb-4" />
            <h3 className="font-bold text-[#10233f] mb-1.5">Business Address</h3>
            <p className="text-sm text-[#5a6b85] leading-relaxed">{COMPANY.address}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
